
import {
  Obra
} from '../index';


export class ObraDocumentacaoDocumento {
  "ObraId";
  "situacao";
  "tipoDeDocumentacaoDaObra";
  "historico";
  "quantidadeDeValidacoes";
  "arquivoNome";
  "dataDaValidacao";
  "dataDaPostagem";
  "id";
  Obra;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ObraDocumentacaoDocumento`.
   */
  static getModelName() {
    return "ObraDocumentacaoDocumento";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ObraDocumentacaoDocumento for dynamic purposes.
  **/
  static factory(data) {
    return new ObraDocumentacaoDocumento(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ObraDocumentacaoDocumento',
      plural: 'ObraDocumentacaoDocumentos',
      path: 'ObraDocumentacaoDocumentos',
      properties: {
        "ObraId": {
          name: 'ObraId',
          type: 'string'
        },
        "situacao": {
          name: 'situacao',
          type: 'string'
        },
        "tipoDeDocumentacaoDaObra": {
          name: 'tipoDeDocumentacaoDaObra',
          type: 'string'
        },
        "historico": {
          name: 'historico',
          type: 'string'
        },
        "quantidadeDeValidacoes": {
          name: 'quantidadeDeValidacoes',
          type: 'number'
        },
        "arquivoNome": {
          name: 'arquivoNome',
          type: 'string'
        },
        "dataDaValidacao": {
          name: 'dataDaValidacao',
          type: 'Date'
        },
        "dataDaPostagem": {
          name: 'dataDaPostagem',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        Obra: {
          name: 'Obra',
          type: 'Obra',
          model: 'Obra'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ObraDocumentacaoDocumento.js